import axios from "axios";
import store from "../store";

/**
 * @description Instancia centralizada de Axios.
 * Toda la comunicación con el backend debe pasar por este cliente.
 * Incluye un interceptor para añadir automáticamente el token de autenticación
 * a todas las peticiones salientes.
 */
const apiClient = axios.create({
    // La URL base de la API con fallback a la URL de producción.
    baseURL: process.env.VUE_APP_API_URL || "https://api.nola.mx/api",
    headers: {
        "Content-Type": "application/json",
    },
});

// Interceptor de peticiones: añade el token a cada request saliente.
apiClient.interceptors.request.use(
    (config) => {
        const token = store.state.auth?.token;
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Interceptor de respuestas: redirige al login si el servidor rechaza el token.
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            store.commit("clearAuth");
            window.location.href = "/";
        }
        return Promise.reject(error);
    }
);

export default apiClient;
